import { MoneyType } from 'data/types'

export type PaymentMethodType = 'PAYMENT_CARD' | 'BANK_TRANSFER' | 'FUNDS' | 'BANK_ACCOUNT'

export type AccountStateType = 'PENDING' | 'ACTIVE' | 'BLOCKED'

export enum CURRENCY_TYPE {
  CRYPTO = 'CRYPTO',
  FIAT = 'FIAT'
}

export type AgentType = {
  account?: string
  accountType?: string
  address?: string
  code?: string
  country?: string
  memo?: string
  name?: string
  recipient?: string
  recipientAddress?: string
  routingNumber?: string
  swiftCode?: string
}

export type Section = {
  entries: Array<SectionEntry>
  id: string
  name: string
}

export type SectionEntry = {
  help?: string
  id: string
  // true when the field should be highlighted to catch users attention
  isImportant?: boolean
  message: string
  title: string
}

export type Footer = {
  actions?: Array<Action>
  icon?: string // icon url
  id: string
  isImportant?: boolean // true when this footer should be highlighted
  message: string
  title: string
}

export type Action = {
  title: string
  url: string
}

// BE driven dynamic content to render wire instructions
// https://www.notion.so/blockchaincom/Spec-backend-driven-Wire-details-3385f2247f9a4523b20f28fb439c1eea
export type Content = {
  footers: Array<Footer>
  sections: Array<Section>
}

export type AccountType = {
  address: string
  agent?: AgentType
  content: Content
  currency: string
  id: string
  memo?: string // XLM only
  state: AccountStateType
  tag?: string // XRP only
}

export type BeneficiaryType = {
  address: string
  agent?: AgentType
  currency: string
  id: string
  name: string
  state: AccountStateType
}

export type TransactionLegType = {
  amount: MoneyType
  extraAttributes?: Object
  id: string
  insertedAt: string
}

type FullCurrencySum = Record<string, number>
export type CurrencySum = Partial<FullCurrencySum>

export * from './Methods/types'
